
import { supabase } from '@/integrations/supabase/client';

// Simplified auth helper functions that work with the new members table
export const checkUserApprovalStatus = async (userId: string, userEmail: string) => {
  try {
    console.log('[AuthHelper] Checking approval status for user:', userId);
    
    // Direct query to members using the simplified RLS
    const { data: memberData, error } = await supabase
      .from('members')
      .select('approved, id')
      .eq('user_id', userId)
      .maybeSingle();
    
    if (error) {
      console.error('[AuthHelper] Error checking member approval:', error);
      return false;
    }
    
    if (memberData) {
      console.log('[AuthHelper] Found member record, approved:', memberData.approved);
      return memberData.approved || false;
    }
    
    console.log('[AuthHelper] No member record found');
    return false;
  } catch (error) {
    console.error('[AuthHelper] Exception checking approval status:', error);
    return false;
  }
};

export const checkAdminStatus = async (userId: string, userEmail: string) => {
  try {
    console.log('[AuthHelper] Checking admin status for user:', userId);
    
    // Use the security definer function
    const { data: isAdmin, error } = await supabase
      .rpc('current_user_is_admin');
    
    if (error) {
      console.error('[AuthHelper] Error checking admin status:', error);
      return false;
    }
    
    console.log('[AuthHelper] Admin check result:', isAdmin);
    return isAdmin || false;
  } catch (error) {
    console.error('[AuthHelper] Exception checking admin status:', error);
    return false;
  }
};

// New function to validate Nigerian state input
export const validateNigerianState = (state: string): boolean => {
  const validStates = [
    'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa', 'Benue', 
    'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo', 'Ekiti', 'Enugu', 
    'FCT', 'Gombe', 'Imo', 'Jigawa', 'Kaduna', 'Kano', 'Katsina', 'Kebbi', 
    'Kogi', 'Kwara', 'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun', 
    'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara'
  ];
  return validStates.includes(state);
};

// Enhanced security logging function
export const logSecurityEvent = async (action: string, details: any) => {
  try {
    console.log(`[Security] ${action}:`, details);
  } catch (error) {
    console.error('[Security] Failed to log security event:', error);
  }
};
